<div class="">
    <div class="custella-modal d-flex flex-column">
        <div class="custella-modal-header align-items-center">
            <div class="custella-modal-header-text">
                <span>{{translate?.requisition.sections.sec15.singular}}</span>
            </div>
            <i class="fa-regular fa-xmark fa-lg" [pTooltip]="translate?.general.buttons.close.singular"
                tooltipPosition="left" (click)="modalRef.hide()"></i>
        </div>
        <div class="custella-modal-body p-0">
            <div class="custella-form-container box-none m-0">
                <!-- <div class="custella-form-container-title-two-grey ps-4">
                    <div class="flex-align-baseline gap-1">
                        <span><i class="fa-solid fa-circle-check font-green"></i></span>
                        <span class="text-12 font-medium">1.</span>
                        <span class="text-12 font-medium">{{translate?.requisition.fields.approvedBy.singular}}</span>
                        <span class="text-12 font-semiBold">John Wayne</span>
                        <span class="text-12 font-medium">{{translate?.requisition.messages.from}}</span>
                        <span class="text-12 font-semiBold">New York Warehouse Team</span>
                    </div>
                    <div class="flex-align-baseline gap-1">
                        <span><i class="fa-solid fa-circle-check font-green"></i></span>
                        <span class="text-12 font-medium">2.</span>
                        <span class="text-12 font-medium">{{translate?.requisition.fields.approvedBy.singular}}</span>
                        <span class="text-12 font-semiBold">Beyonce</span>
                        <span class="text-12 font-medium">{{translate?.requisition.messages.from}}</span>
                        <span class="text-12 font-semiBold">Alabama Team</span>
                    </div>
                </div> -->
                <!-- Request Details -->
                <div class="custella-form-container-title-two-grey-two">
                    <span class="text-14">{{translate?.requisition.sections.sec12.singular}}</span>
                </div>
                <div class="custella-form-container-content">
                    <div class="location-container">
                        <div class="location from">
                            <span class="label mandatory">{{translate?.requisition.fields.from.singular}}</span>
                            <span class="value">{{requisitions?.fromBin.displayName}}</span>
                        </div>

                        <div class="arrow-divider">
                            <div class="circle-arrow">
                                <i class="fa-regular fa-chevron-right"></i>
                            </div>
                        </div>

                        <div class="location to">
                            <span class="label mandatory">{{translate?.consignment.fields.to.singular}}</span>
                            <span class="value">{{requisitions?.toBin.displayName}}</span>
                        </div>
                    </div>
                </div>

                <!-- Asset/Spare Part -->
                <div class="custella-form-container-title-two-grey-two">
                    <span class="text-14">{{translate?.asset.label.plural}}</span>
                </div>
                <div *ngIf="requestTypeOption === 'specificAssets'" class="custella-form-container-content my-0 px-2">
                    <p-table [value]="requisitionData" responsiveLayout="scroll">
                        <ng-template pTemplate="header">
                            <tr class="">
                                <th class="col-3" id="label_GlobalConsignmentRequestSummaryAssetSerialNo">{{translate?.asset.fields.serialNo.singular}}</th>
                                <th class="col-3" id="label_GlobalConsignmentRequestSummaryAssetName">{{translate?.asset.label.singular}}</th>
                                <th class="col-3" id="label_GlobalConsignmentRequestSummaryAssetType">{{translate?.asset.fields.type.singular}}</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-requisitionData>
                            <tr class="text-12 font-medium">
                                <td class="col-3" id="value_GlobalConsignmentRequestSummaryAssetSerialNo">{{requisitionData?.assets?.serialNo ? requisitionData?.assets?.serialNo:'-'}}</td>
                                <td class="col-3" id="value_GlobalConsignmentRequestSummaryAssetName">{{requisitionData?.assets?.name}}</td>
                                <td class="col-3" id="value_GlobalConsignmentRequestSummaryAssetType">{{requisitionData.assetsType ? requisitionData.assetsType?.name:'-'}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <div class="custella-content-row justify-content-end">
                        <span class="text-12 font-medium" id="label_GlobalConsignmentRequestSummaryAssetTotal">{{translate?.general.messages.total}}&colon; {{requisitionData.length}}</span>
                    </div>
                </div>
            <div *ngIf="requestTypeOption === 'selectFromBin'"class="custella-form-container-content my-0 px-2">
                <p-table [value]="requisitionData" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr class="">
                            <th class="col-2" id="label_GlobalConsignmentRequestSummaryAssetSerialNo">{{translate?.product.fields.sku.singular}}</th>
                            <th class="col-2" id="label_GlobalConsignmentRequestSummaryAssetName">{{translate?.product.fields.productName.singular}}</th>
                            <th class="col-2" id="label_GlobalConsignmentRequestSummaryAssetType">{{translate?.product.fields.type.singular}}</th>
                            <th class="col-2 " id="label_GlobalConsignmentRequestSummaryAssetModel">{{translate?.inventory.fields.qtyAvail.singular}}</th>
                            <th class="col-2 " id="label_GlobalConsignmentRequestSummaryInventoryQty">{{translate?.inventory.fields.qty.singular}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-requisitionData>
                        <tr class="text-12 font-medium">
                            <td class="col-2" id="value_GlobalConsignmentRequestSummaryAssetSerialNo">{{requisitionData.product?.productSku}}</td>
                            <td class="col-2" id="value_GlobalConsignmentRequestSummaryAssetName">{{requisitionData.product?.name}}</td>
                            <td class="col-2" id="value_GlobalConsignmentRequestSummaryAssetType">{{requisitionData.product.productType.label}}</td>
                            <td class="col-2" id="value_GlobalConsignmentRequestSummaryAssetType">{{requisitionData.availableQuantity}}</td>
                            <td class="col-2" id="value_GlobalConsignmentRequestSummaryAssetType">{{requisitionData.quantity}}</td>
                        </tr>
                    </ng-template>
                </p-table>
                <div class="custella-content-row justify-content-end">
                    <span class="text-12 font-medium" id="label_GlobalConsignmentRequestSummaryAssetTotal">{{translate?.general.messages.total}}&colon; {{totalQuantity}}</span>
                </div>
            </div>

            <div *ngIf="requestTypeOption == 'assetType'" class="custella-form-container-content my-0 px-2">
                <p-table [value]="requisitionData" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr class="">
                            <th class="col-3 " id="label_GlobalConsignmentRequestSummaryAssetType">{{translate?.asset.fields.type.singular}}</th>
                            <th class="col-3 " id="label_GlobalConsignmentRequestSummaryAssetCategory">{{translate?.asset.fields.category.singular}}</th>
                            <th class="col-2 " id="label_GlobalConsignmentRequestSummaryAssetSubCategory">{{translate?.asset.fields.subCategory.singular}}</th>
                            <th class="col-2 " id="label_GlobalConsignmentRequestSummaryAssetModel">{{translate?.asset.fields.model.singular}}</th>
                            <th class="col-2 " id="label_GlobalConsignmentRequestSummaryInventoryQty">{{translate?.inventory.fields.qty.singular}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-requisitionData>

                        <tr class="text-12 font-medium">
                            <td class="col-3" id="value_GlobalConsignmentRequestSummaryAssetType">{{requisitionData.assetsType?.label}}</td>
                            <td class="col-3" id="value_GlobalConsignmentRequestSummaryAssetCategory">{{requisitionData.assetsCategory}}</td>
                            <td class="col-3" id="value_GlobalConsignmentRequestSummaryAssetSubCategory">{{requisitionData.assetsSubCategory}}</td>
                            <td class="col-3" id="value_GlobalConsignmentRequestSummaryAssetModel">{{requisitionData.model}}</td>
                            <td class="col-3" id="value_GlobalConsignmentRequestSummaryInventoryQty">{{requisitionData.quantity}}</td>
                        </tr>
                    </ng-template>
                </p-table>
                <div class="custella-content-row justify-content-end">
                    <span class="text-12 font-medium" id="label_GlobalConsignmentRequestSummaryAssetTotal">{{translate?.general.messages.total}}&colon; {{totalQuantity}}</span>
                </div>
            </div>

            <div *ngIf="requestTypeOption == 'requestFromBin'" class="custella-form-container-content my-0 px-2">
                <p-table [value]="requisitionData" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr class="">
                            <th class="col-3 " id="label_GlobalConsignmentRequestSummaryAssetType">{{translate?.product.fields.productName.singular}}</th>
                            <th class="col-3 " id="label_GlobalConsignmentRequestSummaryAssetCategory">{{translate?.product.fields.type.singular}}</th>
                            <th class="col-2 " id="label_GlobalConsignmentRequestSummaryAssetSubCategory">{{translate?.product.fields.productFamily.singular}}</th>
                            <th class="col-2 " id="label_GlobalConsignmentRequestSummaryAssetModel">{{translate?.asset.fields.model.singular}}</th>
                            <th class="col-2 " id="label_GlobalConsignmentRequestSummaryInventoryQty">{{translate?.inventory.fields.qty.singular}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-requisitionData>

                        <tr class="text-12 font-medium">
                            <td class="col-3" id="value_GlobalConsignmentRequestSummaryAssetType">{{requisitionData.product?.name}}</td>
                            <td class="col-3" id="value_GlobalConsignmentRequestSummaryAssetCategory">{{requisitionData.productType?.label}}</td>
                            <td class="col-3" id="value_GlobalConsignmentRequestSummaryAssetSubCategory">{{requisitionData.family}}</td>
                            <td class="col-3" id="value_GlobalConsignmentRequestSummaryAssetModel">{{requisitionData.model}}</td>
                            <td class="col-3" id="value_GlobalConsignmentRequestSummaryInventoryQty">{{requisitionData.quantity}}</td>
                        </tr>
                    </ng-template>
                </p-table>
                <div class="custella-content-row justify-content-end">
                    <span class="text-12 font-medium" id="label_GlobalConsignmentRequestSummaryAssetTotal">{{translate?.general.messages.total}}&colon; {{totalQuantity}}</span>
                </div>
            </div>

            <div *ngIf="requestTypeOption === 'custom'" class="custella-form-container-content my-0 px-2">
                <p-table [value]="requisitionData" responsiveLayout="scroll">
                    <ng-template pTemplate="header">
                        <tr class="">
                            <th class="col-8 " id="label_GlobalConsignmentRequestSummaryCustomDesc"> {{translate?.asset.fields.description.singular }}</th>
                            <th class="col-4" id="label_GlobalConsignmentRequestSummaryCustomQty">{{translate?.inventory.fields.qty.singular}}
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-requisitionData>

                        <tr class="text-12 font-medium">
                            <td class="col-8" id="value_GlobalConsignmentRequestSummaryCustomDesc">{{requisitionData.description}}</td>
                            <td class="col-4" id="value_GlobalConsignmentRequestSummaryCustomQty">{{requisitionData.quantity}}</td>
                        </tr>
                    </ng-template>
                </p-table>
                <div class="custella-content-row justify-content-end">
                    <span class="text-12 font-medium" id="label_GlobalConsignmentRequestSummaryCustomTotal">{{translate?.general.messages.total}}&colon; {{totalCustomFormQuantity}}</span>
                </div>
            </div>


                <!-- Request Note -->
                <div class="custella-form-container-title-two-grey-two">
                    <span class="text-14">{{translate?.requisition.fields.requestNote.singular}}</span>
                </div>
                <div class="custella-form-container-content">
                    <div class="custella-content-row mb-3">
                        <div class="custella-content-row-input col-12">
                            <span class="custella-content-row-input-title-three">
                              {{requisitions?.notes ? requisitions?.notes:'-'}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="custella-modal-footer flex-align-end justify-content-between">
            <div class="col-6 text-start">
                <span class="text-12">{{translate?.requisition.fields.remark.singular}}</span>
                <textarea pInputTextarea rows="5" cols="30" [maxlength]="320000" autoResize="autoResize" [placeholder]="translate?.general.messages.none" [(ngModel)]="comment"></textarea>                 
            </div>    
            <div class="flex-align-center justify-content-end">
                <button class="custella-btn-white text-12 ms-2" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular}}</button>
                    <button pButton (click)="binTransfersUpdateStatus('APPROVED',requisitions)"  class="p-button-success ms-2 h-32" id="btn_InvRequisApprove">{{translate?.general.buttons.approve.singular}}</button>
                    <button pButton (click)="binTransfersUpdateStatus('REJECTED',requisitions)" type="button" [label]="translate?.general.buttons.reject.singular" id="btn_InvRequisReject" class="p-button-danger ms-2 h-32"></button>
            </div>
        </div>
    </div>
</div>

<!-- Accept and Reject Button Action -->
<div class="custella-custom-dialog">
    <p-confirmDialog #acceptDeclineBinTransfer  [style]="{width: '30vw'}" [baseZIndex]="10000" key="binTransfer">
        <ng-template pTemplate="header">
            <div class="d-flex align-items-center">
                <img  src="assets/svg/dialog/Confirmation-w.svg" id="img_ConfirmLogo"> 
                <div  class="text-16 font-medium ms-3" id="title_AcceptCancelBinTrans">{{optionLabel}}</div>
            </div>
        </ng-template>
        <p-footer>
            <div class="d-flex align-items-center justify-content-end">
                <button class="custella-btn-white ms-2" id="btn_InvBinTransferCancel" (click)="acceptDeclineBinTransfer.reject()">{{translate?.general.buttons.cancel.singular}}</button>
                <button *ngIf="actionData == 'APPROVED'" pButton (click)="acceptDeclineBinTransfer.accept()"  class="p-button-success h-32" id="btn_InvRequisApprove">{{translate?.general.buttons.approve.singular}}</button>
                <button *ngIf="actionData == 'REJECTED'" pButton (click)="acceptDeclineBinTransfer.accept()" type="button" [label]="translate?.general.buttons.reject.singular" id="btn_InvRequisReject" class="p-button-danger h-32"></button>

            </div>
        </p-footer>
    </p-confirmDialog>
</div>